export const isSomeEnum = <TEnum extends Record<string, unknown>>(
  enumType: TEnum
) => (payload: unknown): payload is TEnum[keyof TEnum] =>
  Object.values(enumType).includes(payload as TEnum[keyof TEnum]);
